import { render, staticRenderFns } from "./Event-section5.vue?vue&type=template&id=a5da52e8"
import script from "./Event-section5.vue?vue&type=script&lang=js"
export * from "./Event-section5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports